import { toast } from "react-toastify";
import { apiFormatGet, apiFormatPostFullCtrl } from "../Api/ApiFormat";

export const clearCacheData = () => {
    caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name);
        });
    });
};

export const validatePanCard = (panCardNumber) => {
    const panCardRegex = /([A-Z || a-z]){3}([P || C || p || c]){1}([A-Z || a-z]){1}([0-9]){4}([A-Z || a-z]){1}$/;
    return panCardRegex.test(panCardNumber.trim());
};

export const GetPayRentCharges = async (amount, opCode) => {
    let charge;
    let userId = sessionStorage.getItem("userId");
    let commission = await apiFormatGet(
        "api/PayRent/GetPayRentCharges",
        `/${userId}/${opCode}`
    );
    if (
        commission &&
        commission.data &&
        commission.data[0].ChargesType == "Percentage"
    ) {
        charge = (commission.data[0].ChargesDeduction / 100) * parseInt(amount);
        charge = charge + charge * 0.18;
    } else if (commission && commission.data && commission.data[0].ChargesType !== null) {
        charge = commission.data[0].ChargesDeduction;
        charge = charge + charge * 0.18;
    } else {
        charge = (1.5 / 100) * parseInt(amount)
    }
    if (charge || charge === 0) return Number(charge.toFixed(2));
};


export const getChargesByUserIdOperatorCode = async (sendData, service) => {
    try {
        const commission = await apiFormatPostFullCtrl(
            "api/Support/GetCommissionByUserId",
            sendData
        );
        if (commission) {
            if (commission.data) {
                if (commission.data.errorCode === "200") {
                    return commission.data.data[0];
                } else {
                    toast.error(
                        commission.data.msg ??
                        `Some error occured in getting ${service} payment charges!`
                    );
                }
            } else {
                toast.error(
                    `Some error occured in getting ${service} payment charges!`
                );
            }
        } else {
            toast.error(
                `Some error occured in getting ${service} payment charges!`
            );
        }

    } catch (err) {
        toast.error(err.message);
    }
};
